import {
  BMC_BLOCKS,
} from '../common_components/bmc/bmc_constants';

import KeyResourcesForm from './KeyResourcesForm';
import CustomerSegmentsForm from './CustomerSegmentsForm';
import ValuePropositionForm from './ValuePropositionForm';
import ChannelsForm from './ChannelsForm';
import CustomerRelationshipsForm from './CustomerRelationshipsForm';
import RevenueStreamsForm from './RevenueStreamsForm';
import KeyActivitiesForm from './KeyActivitiesForm';
import KeyPartnersForm from './KeyPartnersForm';
import CostStructureForm from './CostStructureForm';


const STEP_BY_STEP_FORM_COMPONENTS = {
  [BMC_BLOCKS.CUSTOMER_SEGMENTS]: CustomerSegmentsForm,
  [BMC_BLOCKS.KEY_PROPOSITIONS]: ValuePropositionForm,
  [BMC_BLOCKS.CHANNELS]: ChannelsForm,
  [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: CustomerRelationshipsForm,
  [BMC_BLOCKS.KEY_RESOURCES]: KeyResourcesForm,
  [BMC_BLOCKS.REVENUE_STREAMS]: RevenueStreamsForm,
  [BMC_BLOCKS.KEY_ACTIVITIES]: KeyActivitiesForm,
  [BMC_BLOCKS.KEY_PARTNERS]: KeyPartnersForm,
  [BMC_BLOCKS.COST_STRUCTURE]: CostStructureForm,
};


export {
  STEP_BY_STEP_FORM_COMPONENTS,
};
